import React from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import AlertsView from './AlertsView'
import NoAlertsView from './NoAlertsView'
import * as AlertActionCreators from '../../actions/alert'
import * as CommunityActionCreators from '../../actions/community'
import * as TimeseriesActionCreators from '../../actions/timeseries'

class CommunityAlertsContainer extends React.Component {
  static propTypes = {
    /* passed props */
    communityId: PropTypes.number.isRequired,
    /* mapped state */
    alerts: PropTypes.object.isRequired,
    alertsByCommunity: PropTypes.object.isRequired,
    communities: PropTypes.object.isRequired,
    timeseries: PropTypes.object.isRequired,
    /* mapped dispatch */
    alertActions: PropTypes.object.isRequired,
    communityActions: PropTypes.object.isRequired,
    timeseriesActions: PropTypes.object.isRequired,
  }

  static mapStateToProps(state) {
    return {
      alerts: state.alerts,
      alertsByCommunity: state.alertsByCommunity,
      communities: state.communities,
      timeseries: state.timeseries,
    }
  }

  static mapDispatchToProps(dispatch) {
    return {
      alertActions: bindActionCreators(AlertActionCreators, dispatch),
      communityActions: bindActionCreators(CommunityActionCreators, dispatch),
      timeseriesActions: bindActionCreators(TimeseriesActionCreators, dispatch),
    }
  }

  componentDidMount() {
    const { communityId } = this.props
    this.props.alertActions.listAlertsByCommunity(communityId)
    this.props.communityActions.fetchCommunity(communityId)
  }

  componentDidUpdate() {
    const { timeseriesActions } = this.props
    this.alerts().forEach((alert) => {
      timeseriesActions.fetchTimeseries(alert.timeseries_id)
    })
  }

  alerts() {
    const { alerts } = this.props
    const alertIds = this.props.alertsByCommunity[this.props.communityId] || []
    const communityAlerts = []

    alertIds.forEach((alertId) => {
      const alert = alerts[alertId]
      if (alert && alert.timeseries_id !== 0) {
        communityAlerts.push(alert)
      }
    })

    return communityAlerts
  }

  community() {
    return this.props.communities[this.props.communityId] || {}
  }

  render() {
    const { timeseries } = this.props
    const alerts = this.alerts()

    if (alerts.length > 0) {
      return (
        <AlertsView alerts={alerts} timeseries={timeseries} />
      )
    }

    return (
      <NoAlertsView text={`There are no alerts for ${this.community().name || 'this community'}`} />
    )
  }
}

export default connect(
  CommunityAlertsContainer.mapStateToProps,
  CommunityAlertsContainer.mapDispatchToProps,
)(CommunityAlertsContainer)
